import { useRoutes, Navigate } from 'react-router-dom';
import Home from '@/pages/dashboard/home';
import chatRoutes from '@/pages/chat/routes';
import dashboardRoutes from '@/pages/dashboard/routes';

const Routes = () => {
  const routes = useRoutes([
    // {
    //   path: '/',
    //   element: <Home />,
    // },
    ...chatRoutes,
    ...dashboardRoutes,
   ]);

  return routes;
};

export default Routes;
